var _ellipse, _path, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5,
    cy: 21.0223,
    rx: 20.5,
    ry: 20.5653,
    fill: "#D8D8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8823 10.1367L14.4706 12.5562H10.8529C9.52457 12.5562 8.44116 13.643 8.44116 14.9756V29.4923C8.44116 30.8249 9.52457 31.9117 10.8529 31.9117H30.147C31.4754 31.9117 32.5588 30.8249 32.5588 29.4923V14.9756C32.5588 13.643 31.4754 12.5562 30.147 12.5562H26.5294L24.1176 10.1367H16.8823ZM20.5 16.1853C23.8774 16.1853 26.5294 18.8458 26.5294 22.2339C26.5294 25.6221 23.8774 28.2826 20.5 28.2826C17.1226 28.2826 14.4706 25.6221 14.4706 22.2339C14.4706 18.8458 17.1226 16.1853 20.5 16.1853ZM20.5 17.9999C18.1683 17.9999 16.2794 19.8948 16.2794 22.2339C16.2794 24.5731 18.1683 26.468 20.5 26.468C22.8317 26.468 24.7206 24.5731 24.7206 22.2339C24.7206 19.8948 22.8317 17.9999 20.5 17.9999Z",
    fill: "#3D484D"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 10,
    width: 25,
    height: 22
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8823 10.1367L14.4706 12.5562H10.8529C9.52457 12.5562 8.44116 13.643 8.44116 14.9756V29.4923C8.44116 30.8249 9.52457 31.9117 10.8529 31.9117H30.147C31.4754 31.9117 32.5588 30.8249 32.5588 29.4923V14.9756C32.5588 13.643 31.4754 12.5562 30.147 12.5562H26.5294L24.1176 10.1367H16.8823ZM20.5 16.1853C23.8774 16.1853 26.5294 18.8458 26.5294 22.2339C26.5294 25.6221 23.8774 28.2826 20.5 28.2826C17.1226 28.2826 14.4706 25.6221 14.4706 22.2339C14.4706 18.8458 17.1226 16.1853 20.5 16.1853ZM20.5 17.9999C18.1683 17.9999 16.2794 19.8948 16.2794 22.2339C16.2794 24.5731 18.1683 26.468 20.5 26.468C22.8317 26.468 24.7206 24.5731 24.7206 22.2339C24.7206 19.8948 22.8317 17.9999 20.5 17.9999Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.ee4b1b7b28d551d80c9801f4d8a99296.svg";
export { ForwardRef as ReactComponent };